/**
 * Get the unique values of an array
 * @see https://phuoc.ng/collection/1-loc/get-the-unique-values-of-an-array/
 * @param arr
 * @returns
 */
export const unique = <T>(arr: T[]): T[] => [...new Set(arr)];
